var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNoRequests(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 250 250",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76.2 112c-15.7-16.3-30.3-13.4-36.4-11.1-10.4 3.9-17.6 13.9-16.9 23.3.3 3.4 1.7 6.1 4.1 7.9 5.9 4.7 16.7 3.2 28.9 1.4 9.9-1.5 20.7-2.8 27.6-.7 1.6.5 4.3-.1 4.8-1.7v-.1c.5-1.6-1.3-3.7-3-4.2-8.3-2.5-20.2-1.2-30.8.4-9.9 1.5-20.1 3-23.9 0-.6-.5-1.4-1.4-1.6-3.5-.5-6.6 5.1-14.1 12.9-17 9.4-3.5 19.7-.3 29 8.9 1.2-1.3 2.7-2.4 4.4-3.2.3-.2.6-.3.9-.4z",
    opacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M90.4 212.3l-25.5-50c-1.8-3.6 0-12.5 1.1-20.9.3-2.2.7-4.6 1.1-7 6-.5 11.8-.5 15.9.7 2.6.8 5.3-1.6 5.8-3.4 1.4-4.4-.8-6.8-2.6-7.3-5-1.5-10.9-1.7-17.2-1.3.3-1.5.4-2.3.4-2.3 1-2.9 3.6-5.5 6.7-6.9 2.2-1.2 4.9-1.8 7.7-1.2l1.2.3s12.1 5.7 12.3 5.6c2.2 1.1 4.4 2.2 6.3 3.2 7.5 4 15.8 7.8 17.6 11.3l25.5 50c1.3 2.6 1.1 6-.2 8.9-.6 2-1.9 3.7-3.7 4.7l-39.2 20c-4.3 2.2-11.1-.1-13.2-4.4zm42-186.5l7.9 28.8 28.2 9.8-25 16.4-.6 29.8L119.6 92 91 100.6l10.6-27.9-17.1-24.5 29.8 1.4m55.8 51.1l11 19.2 22.2 1.9-15 16.4 5.1 21.7-20.2-9.2-19 11.5 2.4-22-16.8-14.5 21.7-4.6m33.4-55.6l6.1 10.7 12.2 1-8.2 9.1 2.8 11.9-11.2-5-10.5 6.3 1.3-12.2-9.3-8 12.1-2.5",
    opacity: 0.1
  })));
}

export default SvgNoRequests;